import React from 'react';
import './app.css';

const App = () => (
  <div>
    You made it to the app
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.js